import { Component, OnInit, Input } from '@angular/core';
import { LabMDM, SelectableLab } from '../masterdata/models/lab';
import { MessagesService } from '../messages/messages.service';
import { ProblemService } from './problem-service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ErrorHandler } from '../utils/error-handler';
import { ProblemDTO } from '../masterdata/models/problem';
import { ProblemCategoryDTO } from '../masterdata/models/problemCategory';
import { LabEmitterService } from '../common-services/lab-emitter.service';

@Component({
  selector: 'app-problem',
  templateUrl: './problem.component.html',
  styleUrls: ['./problem.component.css']
})
export class ProblemComponent implements OnInit {

  @Input() masterLists: ProblemDTO[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() checkSelectedLab: SelectableLab;

  labOption: LabMDM[] =[];

  labOptions: LabMDM[];
  isNewMasterList: boolean;
  masterList: ProblemDTO;
  displayMasterListDialog: boolean = false;
  selectedLabName: string;
  selectedLab: LabMDM;
  selectedCategory: ProblemCategoryDTO;
  errorHandler: ErrorHandler = new ErrorHandler;
  selectedMasterList: ProblemDTO;
  isActive: string = "active";
  isLab: string = "lab";
  isCategory: string = "category";
  isProblem: string = "problemName";
  isDescription: string = 'description';
  isSeverity: string = 'severity';
  isExtProblemCode: string = 'extProblemCode';
  isStandardCode: string = 'standardCode';
  problemOptions: ProblemCategoryDTO[] = [];
  selectedLabToBeUsed: SelectableLab;

  constructor(private _messageService: MessagesService, private _labEmitterService: LabEmitterService,private problemService: ProblemService, private _masterDataService: MasterDataService) { }

  ngOnInit() {
    this._labEmitterService.change.subscribe(lab => {
        this.selectedLabToBeUsed = lab;
        console.log("Seleted lab in masterData(e): " + this.selectedLabToBeUsed.label)
    });
    this.selectedLabToBeUsed = JSON.parse(localStorage.getItem('lab'));

  }

  //Display master Dialog upon clicked on a row
  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.getActiveOptionsForDropdowns();
    this.displayMasterListDialog = true;
  }
//Retrieve the Active lab for dropdown
getActiveOptionsForDropdowns() {
  this.labOption=[];
  this.populateProblemsList();
  this._masterDataService.getLabs(true).subscribe(
    results => {
      if (!results) {
        return;
      }   let checkSelectedLabName = this.checkSelectedLab.lab.name;
      this.labOptions = results.data;
      this.labOptions.forEach(lab => {
        
        if(lab.name == checkSelectedLabName) {
          this.labOption.push(lab);
        }
        if (this.masterList?.lab && lab._id == this.masterList.lab._id) {
          this.selectedLabName = this.masterList.lab.name;
          this.selectedLab = lab;
        }
      })
      this.labOptions= this.labOption;
      if (!this.masterList?.lab || this.selectedLabName != this.masterList.lab.name)
        this.selectedLab = null;
    },
    error => {
      let message = this.errorHandler.handleError(error);
      this._messageService.addErrorMessage(message);
      }
  );

}

  //Display Add Dialog upon clicking Add button
  showDialogToAddMasterList() {

    this.isNewMasterList = true;
    this.masterList = new ProblemDTO;
    this.masterList.severity = 0;
    this.getActiveOptionsForDropdowns();
    this.selectedLab = null;
    this.selectedCategory = null;
    this.displayMasterListDialog = true;
  }

  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }

  //Insert or update Template
  saveMasterList() {
    let masterLists = [...this.masterLists];
    if (this.isNewMasterList) {
      this.saveMasterData(masterLists);
    }
    else {
      this.updateMasterData(masterLists);
    }
  }

  //Inserts a new Template in DB
  saveMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.masterList.category = this.selectedCategory.categoryName;
    this.problemService.addProblem(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists = [...this.masterLists];
        masterLists.push(results.data);
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  //Updates a Template in DB
  updateMasterData(masterLists: any[]) {
    this.masterList.lab = new LabMDM();
    this.masterList.lab = this.selectedLab;
    this.masterList.category = this.selectedCategory.categoryName;
    this.problemService.updateProblem(this.masterList).subscribe(
      results => {
        if (!results) {
          return;
        }
        masterLists[this.masterLists.indexOf(this.selectedMasterList)] = results.data;
        this.masterLists = masterLists;
        this.masterList = null;
        this.displayMasterListDialog = false;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

  isSaveDisabled() {
    return (this.masterList == undefined || this.masterList.problemName == "" || this.masterList.extProblemCode == "" ||
      this.selectedLab == null  || this.severityCheck() || this.selectedCategory == null)
  }
  severityCheck() {
    return (this.masterList.severity > 999 || this.masterList.severity < 0 || this.masterList.severity == null)
  }
  populateProblemsList() {
    this.problemOptions = [];
    console.log("dd",this.selectedLabToBeUsed);
    this._masterDataService.getProblemCategoriesList(this.selectedLabToBeUsed.lab).subscribe(
      results => {
        if (!results) {
          return;
        }
        this.problemOptions = results.data;
        this.problemOptions.forEach(ele => {
          if (this.masterList?.category && ele.categoryName == this.masterList.category) {
            this.selectedCategory = ele;
          }
          if (!this.masterList?.category || !this.selectedCategory || this.selectedCategory.categoryName != this.masterList.category) {
            this.selectedCategory = null;
          }

        });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );

  }
}
